import { useHandlers } from '../../../context/page-context';
import type { PurchasingApiContract } from '../api/purchasing';

export function usePurchasingApi(): { purchasingApi: PurchasingApiContract } {
  const { apis } = useHandlers();
  return { purchasingApi: apis.purchases };
}
